import React, { useState, useEffect } from "react";
import { db, storage } from "../../utils/firebase";
import { collection, getDocs, deleteDoc, doc, setDoc, getDoc } from "firebase/firestore";
import { ref, getDownloadURL } from "firebase/storage";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";
import './PostsArchive.css'; // Custom styles
import { Link, useLocation } from 'react-router-dom';

const PostsArchive = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  // Fetch posts from posts_archive
  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const postsArchiveCollectionRef = collection(db, "posts_archive");
        const snapshot = await getDocs(postsArchiveCollectionRef);
  
        if (!snapshot.empty) {
          const postsData = await Promise.all(
            snapshot.docs.map(async (doc) => {
              const data = doc.data();
  
              const profileImage = data.profileImage || null;
  
              let imageUrls = [];
              if (data.imageUrls && Array.isArray(data.imageUrls) && data.imageUrls.length > 0) {
                imageUrls = await Promise.all(
                  data.imageUrls.map(async (imageName) => {
                    try {
                      const imageRef = ref(storage, `posts/${data.userId}/${imageName}`);
                      const imageUrl = await getDownloadURL(imageRef);
                      console.log("Fetched image URL:", imageUrl); 
                      return imageUrl;
                    } catch (err) {
                      console.error("Error fetching image URL for", imageName, err);
                      return null;  
                    }
                  })
                );
                imageUrls = imageUrls.filter(url => url !== null);
              }
  
              return { id: doc.id, ...data, imageUrls, profileImage };
            })
          );
  
          setPosts(postsData);
        } else {
          console.log("No archived posts found.");
        }
      } catch (error) {
        console.error("Error fetching archived posts: ", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchPosts();
  }, []);
  
  
  
  
  const handleRestorePost = async (postId) => {
    try {
      const postRef = doc(db, "posts_archive", postId);
      const postSnap = await getDoc(postRef);

      if (postSnap.exists()) {
        const postData = postSnap.data();

        // Add the post back to the posts collection
        await setDoc(doc(db, "posts", postId), postData);

        // Remove the post from posts_archive
        await deleteDoc(postRef);

        // Update local state
        setPosts((prevPosts) => prevPosts.filter((post) => post.id !== postId));
        console.log(`Post ${postId} restored to UserPosts.`);
      } else {
        console.error("Post not found in archive.");
      }
    } catch (error) {
      console.error("Error restoring post: ", error);
    }
  };

  // Permanently delete a post
  const handleDeletePost = async (postId) => {
    try {
      await deleteDoc(doc(db, "posts_archive", postId));

      // Update local state
      setPosts((prevPosts) => prevPosts.filter((post) => post.id !== postId));
      console.log(`Post ${postId} permanently deleted.`);
    } catch (error) {
      console.error("Error deleting post: ", error);
    }
  };

  if (loading) return <p>Loading archived posts...</p>;

  return (
    <div className="admin-page">
      <Navbar />
      <div className="admin-container">
      <div className="admin-sidebar">

          <h2>Admin Panel</h2>
          <Link to="/adminusers" className={`sidebar-button ${location.pathname === '/adminusers' ? 'active' : ''}`}>Users</Link>
          <Link to="/adminposts" className={`sidebar-button ${location.pathname === '/adminposts' ? 'active' : ''}`}>User Posts</Link>
          <Link to="/adminfeedback" className={`sidebar-button ${location.pathname === '/adminfeedback' ? 'active' : ''}`}>User Feedback</Link>
          <Link to="/announcementadmin" className={`sidebar-button ${location.pathname === '/announcementadmin' ? 'active' : ''}`}>Announcements</Link>
          <Link to="/exploreaboutadmin" className={`sidebar-button ${location.pathname === '/exploreaboutadmin' ? 'active' : ''}`}>Explore about Bacoor</Link>

          <h2>Places to Visit</h2>
          <Link to="/bridgesadmin" className={`sidebar-button ${location.pathname === '/bridgesadmin' ? 'active' : ''}`}>Bridges & Dams</Link>
          <Link to="/monumentsadmin" className={`sidebar-button ${location.pathname === '/monumentsadmin' ? 'active' : ''}`}>Monuments & Statues</Link>
          <Link to="/houseadmin" className={`sidebar-button ${location.pathname === '/houseadmin' ? 'active' : ''}`}>Ancestral Houses</Link>
          <Link to="/churchesadmin" className={`sidebar-button ${location.pathname === '/churchesadmin' ? 'active' : ''}`}>Churches & Religious Sites</Link>

          <h2>Things to Do</h2>
          <Link to="/recreationaladmin" className={`sidebar-button ${location.pathname === '/recreationaladmin' ? 'active' : ''}`}>Recreational Activities</Link>
          <Link to="/diningadmin" className={`sidebar-button ${location.pathname === '/diningadmin' ? 'active' : ''}`}>Dining and Culinary</Link>
          <Link to="/shoppingadmin" className={`sidebar-button ${location.pathname === '/shoppingadmin' ? 'active' : ''}`}>Shopping and Market</Link>

          <h2>Archives</h2>
          <Link to="/userarchive" className={`sidebar-button ${location.pathname === '/userarchive' ? 'active' : ''}`}>Users</Link>
          <Link to="/postsarchive" className={`sidebar-button ${location.pathname === '/postsarchive' ? 'active' : ''}`}>Posts</Link>
          <Link to="/feedbackarchive" className={`sidebar-button ${location.pathname === '/feedbackarchive' ? 'active' : ''}`}>Feedback</Link>
          <Link to="/announcementarchive" className={`sidebar-button ${location.pathname === '/announcementarchive' ? 'active' : ''}`}>Announcements</Link>
        </div>
        <div className="admin-content">
          <h2>Archived Posts</h2>
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Profile</th>
                  <th>User</th>
                  <th>Text</th>
                  <th>Location</th>
                  <th>Rating</th>
                  <th>Date Created</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
              {posts.map((post) => (
                        <tr key={post.id}>
                            <td>
                            <img
                                src={post.profileImage || ""}
                                alt={`${post.userName}'s profile`}
                                style={{ maxWidth: "50px", borderRadius: "50%" }}
                            />
                            </td>
                            <td>{post.userName || "Unknown"}</td>
                            <td>{post.text || "No text"}</td>
                            <td>{post.location || "Unknown"}</td>
                            <td>{post.rating || "N/A"}</td>
                            
                            <td>
                            {post.createdAt
                                ? new Date(post.createdAt.seconds * 1000).toLocaleString()
                                : "N/A"}
                            </td>
                            <td>
                            <button
                                className="restore-btn"
                                onClick={() => handleRestorePost(post.id)}
                            >
                                <i className="bi bi-arrow-clockwise"></i>
                            </button>
                            <button
                                className="delete-btn"
                                onClick={() => handleDeletePost(post.id)}
                            >
                              <i className="bi bi-trash"></i>
                            </button>
                            </td>
                        </tr>
                        ))}

              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PostsArchive;
